export default {"src":"/_next/static/media/Members.079b2b1b.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};